import { Container, Card, CardHeader } from "reactstrap";

import BreadCrumb from "components/common/BreadCrumb";

import { EnquirySiteVisitsTable } from "./EnquirySiteVisitsTable";
import { Link } from "react-router-dom";
import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const EnquirySiteVisitList = (props: any) => {
  document.title = getDocumentTitle("Site Visits");
  const { can } = useAccess();

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Site Visits" pageTitle="Enquiry Management" />
        <Card>
          <CardHeader className="d-flex flex-wrap align-items-start align-items-sm-center justify-content-between gap-3 border-bottom">
            <div>
              <h5 className="card-title mb-1">Site visits</h5>
              <p className="text-muted small mb-0">
                Scheduled field visits linked to enquiries.
              </p>
            </div>
            <div className="d-flex flex-wrap gap-2 flex-shrink-0">
              {can(Permissions.SITE_VISIT.CREATE) ? (
                <Link
                  to="/enquiry-management/site-visits/create"
                  className="btn btn-primary"
                >
                  <i className="ri-add-line align-bottom me-1" />
                  New visit
                </Link>
              ) : null}
            </div>
          </CardHeader>
          <div className="card-body pt-3">
            <EnquirySiteVisitsTable />
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default EnquirySiteVisitList;
